<ng-container *ngIf="loaded">
    <angular2-smart-table [settings]="settings" [source]="source"></angular2-smart-table>
</ng-container>

